import {Spinner} from './components';
import {MODE, NAME, POSITION} from './configs/variables';
const POSITIONS = POSITION.LTR;

export {Spinner as default, MODE, NAME, POSITIONS}
